export default "__VITE_ASSET__D244w$8r__"